module.exports = __webpack_public_path__ + "assets/img/mecha-0012882b.png";